export enum TYPES {
  SET_PHONE_NUMBER = 'setPhoneNumber',
}

export default TYPES
